import "./style.less";
import BasketFixedUrl from "./url";

import BasketFixedToCheckout from "./factory";

import BasketFixedRenewLogic from "./renew-logic";
import BasketFixedController from "./controller";
import BasketFixedComponents from "./components/module";

const modul = angular
    .module("BasketFixed", [BasketFixedComponents])
    .controller("basketFixedController", BasketFixedController)
    .factory("BasketFixedRenewLogic", BasketFixedRenewLogic)
    .factory("BasketFixedToCheckout", BasketFixedToCheckout)

    .factory("BasketFixedUrl", BasketFixedUrl);

export default modul.name;
